import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    tokenavaflex: "",
    adminavaflex: []
  },
  mutations: {
    login(state, data) {
      state.adminavaflex = data.user;
      state.tokenavaflex = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.adminavaflex = [];
      state.tokenavaflex = "";
    },
    adminavaflex(state, data) {
      state.adminavaflex = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("adminavaflex", data);
    }
  }
});
